import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import SkeletonImageIcon from "~/assets/icons/SkeletonImageIcon";
import { IndexFilterObject, ProductFilterObject } from "~/types";
import ProductCard from "./ProductCard.client";
import InfiniteScroll from "react-infinite-scroll-component";
import { showPriceSaleWithDetailText } from "../../../setup/settings/__product";

type Props = {
    loading: boolean,
    products: IndexFilterObject[],
    showFilter: boolean,
    children: IntrinsicAttributes & Props,
    shopSettings: any,
    currency: string,
    scrolling: boolean,
    getFilter: () => void
}

export default function ProductListGrid({ getFilter, loading, products, showFilter, children, shopSettings, currency, scrolling }: Props) {
    //animation
    const duration = 400;
    const delay = 40;

    const animStr = (i) => `fadeIn ${duration}ms ease-out ${delay * (i + 1)}ms forwards`;
    return (
        <LayoutGroup>
            <AnimatePresence>
                <div className="ProductList__products-area">
                    <div className={`ProductList__grid ${showFilter && 'openModal'} flex mb-2`}>
                        {loading ?
                            <SkeletonGrid />
                            :
                            products?.map((p, i) =>
                                <motion.a key={i} className={`link-card ${showPriceSaleWithDetailText.enabled ? "PriceWithText" : ""}`} href={getUrl(p._source)} style={{ opacity: 0, animation: animStr(i - (getFilter().pagination.limit * (getFilter().pagination.page - 1))) }}
                                    animate={{
                                        scale: 1,
                                        transition: { delay: 0.2 }
                                    }}
                                    layout
                                >
                                    <ProductCard shopSettings={shopSettings} key={i} product={p._source} currency={currency} />
                                </motion.a>
                            )}
                    </div>
                    {children}
                </div>
                {/* <div className="flex items-center justify-center mt-6" style={{ opacity: scrolling && products?.length > 0 ? 1 : 0 }}>
                        <div className="loader"></div>
                    </div> */}
            </AnimatePresence>
        </LayoutGroup>
    )
}

const getUrl = (product: ProductFilterObject) => {
    if (product.customfields.redirecturl && product.customfields.redirecturl != '')
        return product.customfields.redirecturl
    else
        return `/products/${product.handle}`;
}

const SkeletonGrid = () => {
    return (
        <>
            {Array(16).fill('').map(_ =>
                <div className="ProductList__product-item animate-pulse">
                    <div className="ProductList__product-container">
                        <div className="ProductList__product-topSection bg-gray-300">
                            <div className="ProductList__card-section-top">
                            </div>
                            <div className="ProductList__product-image">
                                <div className="w-80 h-20 pt-24 pl-32">
                                    <SkeletonImageIcon />
                                </div>
                            </div>
                        </div>
                        <div className="ProductList__product-bottomSection">
                            <div className="ProductList__product-description">
                                <div className="ProductList__product-range w-24 h-2 bg-gray-300 mb-2" />
                                <div className="ProductList__product-brand w-14 h-2 bg-gray-300 mb-2" />
                                <div className="ProductList__product-title w-40 h-4 bg-gray-300" />
                            </div>
                            <div className="ProductList__price-section">
                                <div className="ProductList__customise w-20 h-5 bg-gray-300" data-tooltip="Customise" />
                            </div>
                        </div>
                    </div>
                </div>)}
        </>
    )
}
